import React, { Component } from 'react';
import StepQuestion from './StepQuestion';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { connect } from "react-redux";
import { updateAnswers } from '../../actions/orderActions';
import Card from "../../common/Card";


class StepQuestionList extends Component {
  constructor(props) {
    super();
    const { questions } = props;
    const changedData = {};

    console.log("stepquestionlist", questions);

    if (questions) {
      for (let question of questions) {
        changedData[question.id] = question;
      }
    }
    this.state = { changedData };
  }

  updateAnswer({id, value}) {
    const changedData = { ...this.state.changedData };
    const question = changedData[id];
    question.resposta = value;

    this.setState({ changedData });
  }

  saveAnswers() {
    const ordemServicoId = this.props.orderDetails.id;
    this.props.updateAnswers(ordemServicoId, Object.values(this.state.changedData));
  }

  render() {
    const { questions } = this.props;

    if (!questions) {
      return <React.Fragment/>
    }
    if (questions.length === 0) {
      return <React.Fragment/>;
    }

    return (
      <Grid container spacing={16} direction="row">
        <form style={{ width:'100%'}} onSubmit={() => {}}>
          {questions.map((question, index) => (
            // <Grid item key={index} xs={12} >
              <StepQuestion key={index} question={question} onChange={this.updateAnswer.bind(this)}/>
            // </Grid>
          ))}
          {/*//TODO: recolocar Salvar */}
          {/*<Grid item>*/}
          {/*  <Button variant="contained" onClick={this.saveAnswers.bind(this)}>Salvar</Button>*/}
          {/*</Grid>*/}
        </form>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orderDetails: state.orderDetails
  }
};

export default connect(mapStateToProps, { updateAnswers })(StepQuestionList);
